  <span [ngClass]="cssClass">
  <i class="pi" [ngClass]="icon"></i>
  {{ label }}
</span>
